import React, { createContext, useContext, useMemo, useState } from "react";

type HeadingContextValue = {
  node: React.ReactNode;
  setNode: (n: React.ReactNode) => void;
};

const HeadingContext = createContext<HeadingContextValue | null>(null);

export function HeadingProvider({ children }: { children: React.ReactNode }) {
  const [node, setNode] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ node, setNode }), [node]);
  return <HeadingContext.Provider value={value}>{children}</HeadingContext.Provider>;
}

export function useHeading() {
  const ctx = useContext(HeadingContext);
  if (!ctx) throw new Error("useHeading must be used within HeadingProvider");
  return ctx;
}

export function AppHeadingSlot() {
  const { node } = useHeading();
  return <>{node}</>;
}

